// extracted by mini-css-extract-plugin
export default {"tableContainer":"tableContainer-ck2NQ"};